import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "toggle"];

  static classes = ["collapsed"];

  connect() {
    this.expanded = false;

    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.contentTarget);
    }

    requestAnimationFrame(() => this.update());
  }

  disconnect() {
    this.resizeObserver?.disconnect();
  }

  toggle(event) {
    event.preventDefault();
    this.expanded = !this.expanded;
    this.update();
  }

  update() {
    if (this.expanded) {
      this.contentTarget.classList.remove(this.collapsedClass);
      this.toggleTarget.textContent = "Read Less";
      this.toggleTarget.setAttribute("aria-expanded", "true");
      this.toggleTarget.hidden = false;
      return;
    }

    this.contentTarget.classList.add(this.collapsedClass);
    this.toggleTarget.textContent = "Read More";
    this.toggleTarget.setAttribute("aria-expanded", "false");

    const overflowing =
      this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 1;
    this.toggleTarget.hidden = !overflowing;

    if (!overflowing) {
      this.contentTarget.classList.remove(this.collapsedClass);
    }
  }
}
